<template>
  <div>
    <div class="desc-list">
      <div class="an-head">
        <div class="title">
          <span class="desc-style">
            <span class="qu-num" v-if="answerStyleConfig.common.showQuNumInd === '1'">{{config[questionIndex].quCode}}.</span>
            <span v-if="config[questionIndex].answerConfig.requireInd === '1'" class="require">*</span>
            <span class="qu-title" v-html="config[questionIndex].displayTitle"></span>
            <span v-if="answerStyleConfig.common.showQuestionType === '1'" class="qu-type">
              (<span v-html="config[questionIndex].displayElementDesc"></span>)
            </span>
          </span>
          <div v-if="config[this.questionIndex].imgUrl" class="media-box">
            <ipsos-av v-if="isAv(config[this.questionIndex].imgUrl)" :src="config[this.questionIndex].imgUrl"></ipsos-av>
            <ipsos-image v-else :imgUrl="config[this.questionIndex].imgUrl" :preview="config[this.questionIndex].id"></ipsos-image>
          </div>
        </div>
      </div>
      <div class="an-body">
        <FormItem ref="formItem" prop="selIndexs" :rules="myRules">
          <el-table
            :data="config"
            style="width: 100%"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            :row-class-name="tableRowClassName"
          >
            <!-- 第一列 -->
            <el-table-column min-width="140" class-name="first-column">
              <template slot-scope="scope">
                <div v-if="scope.row.id === config[questionIndex].id">
                  <div v-html="scope.row.descList[scope.row.descIndex].displayTitle"></div>
                </div>
              </template>
            </el-table-column>
            <!-- 动态列 -->
            <template v-for="(item, index) of config[questionIndex].optionList">
              <el-table-column
                v-if="item.visibility"
                :key="index"
                prop="elementDesc"
              >
                <template slot="header" slot-scope="scope">
                  <div v-html="item.displayTitle"></div>
                </template>
                <template slot-scope="scope">
                  <!-- {{ scope.row.optionList[index].displayTitle }}
                  :
                  {{ scope.row.optionList[index].id }} -->
                    <!-- {{ scope.$index }} -->
                    <!-- {{ scope.row.descList[scope.$index].value }} -->
                    <!-- {{ scope.row.optionList[index][optionValueKey] }} -->
                    <!-- {{ scope.row.descList[scope.$index].value }} -->
                    <div v-if="scope.row.id === config[questionIndex].id">
                      {{ con(scope.row) }}
                      <template v-if="!multiple">
                        <el-radio
                          v-model="scope.row.descList[scope.$index - questionIndex].value"
                          :label="scope.row.optionList[index][optionValueKey]"
                          :disabled="scope.row.optionList[index].disabled ? true : false"
                          @change="radioChange(scope.$index - questionIndex)"
                          style="width: 16px;display: inline-block;margin-right: 0;"
                        ><span /></el-radio>
                      </template>
                      <template v-else>
                        <el-checkbox
                          v-model="scope.row.descList[scope.$index - questionIndex].value"
                          :label="scope.row.optionList[index][optionValueKey]"
                          :disabled="scope.row.optionList[index].disabled ? true : false"
                          @change="checkChange(scope.$index - questionIndex, scope.row.optionList[index])"
                          style="width: 16px;display: inline-block;margin-right: 0;"
                        ><span /></el-checkbox>
                      </template>
                      <div v-if="
                        scope.row.optionList[index].type === 'other' &&
                        scope.row.descList[scope.$index - questionIndex].value.indexOf(scope.row.optionList[index][optionValueKey]) > -1
                      " style="display: inline-block;">
                          <Input
                            class="textarea"
                            v-model="scope.row.optionList[index].otherValue"
                            type="textarea"
                            :autosize="{minRows: 1,maxRows: 2}"
                            :maxlength="200"
                            style="width: 80%;"
                          />
                      </div>
                    </div>
                  <!-- type -->
                </template>
              </el-table-column>
            </template>
          </el-table>
        </FormItem>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'AnswerGroupTable',
  props: ['config', 'optionKey', 'optionValueKey', 'multiple', 'answerValidate', 'questionIndex'],
  data () {
    return {
      selIndexs: [],
      selIndex: 0,
      myRules: [
        {
          validator: (rule, value, callback) => {
            let errors = []
            const {requireInd, answerLimitInd, minAnswerNum, maxAnswerNum} = this.config[this.questionIndex].answerConfig

            // 必填
            if (requireInd === '1' && this.validOption() && sessionStorage.getItem('descChangeStatus') === '1') {
              errors.push(this.cvtLang('tipAnswerNull', this.getSurveyInfoLang().tipAnswerNull))
            }
            
            // 矩阵多选选项数量限制
            if (answerLimitInd === '1' && this.config[this.questionIndex].type === 'checkboxgroup' && sessionStorage.getItem('descChangeStatus') === '1') {
              this.config.forEach(item => {
                const currItem = item.descList[item.descIndex]
                // 选项数量
                const selUnknown = this.config[this.questionIndex].optionList.filter(item => currItem.value.includes(item.id) && item.type === 'unknown')

                if (currItem.value && !selUnknown.length && currItem.value.length < Number(minAnswerNum)) {
                  let minAnswerNumPhrase = this.cvtLang('minAnswerNum', this.surveyInfoLang.minAnswerNum) || ''
                  errors.push(minAnswerNumPhrase.replace('${n}', minAnswerNum))
                  return
                } else if (currItem.value && !selUnknown.length && currItem.value.length > Number(maxAnswerNum)) {
                  let maxAnswerNumPhrase = this.cvtLang('maxAnswerNum', this.surveyInfoLang.maxAnswerNum) || ''
                  errors.push(maxAnswerNumPhrase.replace('${n}', maxAnswerNum))
                  return
                }
              })
            }

            if (errors.length) {
              return callback(errors)
            }
            callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapState({
      answerStyleConfig: ({Question}) => Question.answerStyleConfig,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      langMap: ({Question}) => Question.langMap
    }),
    index () {
      return this.config.descIndex
    },
    // isGroupTitle () {
    //   return /^RadioBoxGroup|CheckBoxGroup$/.test(this.config.elementType) && this.index > 0
    // },
    // descList () {
    //   const config = this.config
    //   return config.descList.filter((item, index) => index === config.descIndex)
    // }
  },
  methods: {
    con (item) {},
    isAv (url) {
      return url && url.includes('.mp4')
    },
    validate () {},
    // 子问题行是否隐藏
    tableRowClassName: function (item) {
      if (this.config[this.questionIndex].id !== item.row.id) {
        return 'hidden-row'
      }
      if (!item.row.descList[item.rowIndex - this.questionIndex].visibility) {
        return 'hidden-row'
      }
      return ''
    },
    // 验证选项
    validOption() {
      const {descList} = this.config[this.questionIndex]
      const {otherRequireInd} = this.config[this.questionIndex].answerConfig

      return (descList.filter(item=>{return item.visibility === true || item.visibility === '1'}).length > this.selIndexs.length) || (otherRequireInd === '1' && descList.filter(item=>{return item.visibility === true || item.visibility === '1'}).length === this.selIndexs.length && this.validOther())
    },
    // 验证其他选项
    validOther() {
      const descList = this.config[this.questionIndex].descList.filter(item=>{return item.visibility === true || item.visibility === '1'})

      // 勾选题列表
      let selDescList = []
      for(let i=0; i<descList.length; i++) {
        this.config[this.questionIndex + i].descList.forEach(item => {
          if (item.value && (typeof item.value === 'string')) {
            selDescList.push(item)
          } else {
            if (item.value && item.value.length) {
              selDescList.push(item)
            }
          }
        })
      }

      // 选项列表
      let optionList = []
      for(let i=0; i<descList.length; i++) {
        if (this.config[this.questionIndex + i].optionList) {
          this.config[this.questionIndex + i].optionList.forEach(item => {
            if (item.type === 'other') {
              optionList.push({
                ...item,
                otherValue: item.otherValue ? item.otherValue : ''
              })
            }
          })
        }
      }

      // 遍历取勾选其它结果
      let otherArr = []
      selDescList.forEach((item, index) => {
        if (item.value && (typeof item.value === 'string')) {
          // 单选
          if (optionList[index].id === item.value) {
            otherArr.push(optionList[index])
          }
        } else {
          // 多选
          if (item.value && item.value.length && optionList.length && item.value.includes(optionList[index].id)) {
            otherArr.push(optionList[index])
          }
        }
      })

      // console.log('selDescList', selDescList)
      // console.log('optionList', optionList)
      // console.log('otherArr', otherArr)

      let otherFlg = false
      if (otherArr.length) {
        otherFlg = !otherArr.every(item => {
          return item.otherValue && item.otherValue.trim().length > 0
        })
      }
      return otherFlg
    },
    radioChange(index) {
      sessionStorage.setItem('allOrderByIdStash', this.config[this.questionIndex + index].allOrderById)
      this.selIndex = index
      if (this.selIndexs.indexOf(index) < 0) {
        this.selIndexs.push(index)
      }
      this.$refs.formItem.validate()
    },
    checkChange(index, optionItem) {
      sessionStorage.setItem('allOrderByIdStash', this.config[this.questionIndex + index].allOrderById)
      this.selIndex = index
      const values = this.config[this.questionIndex + index].descList[index].value
      
      if (values.length) {
        if (this.selIndexs.indexOf(index) < 0) {
          this.selIndexs.push(index)
        }
      } else {
        this.selIndexs.some((item, i) => {
          if (item === index) {
            this.selIndexs.splice(i, 1)
          }
        })
      }

      if (optionItem.type === 'unknown') {
        // 勾选”不清楚/不知道“需和其它选项产生互斥关系
        if (values.indexOf(optionItem.id) > -1) {
          this.config[this.questionIndex + index].descList[index].value = [optionItem.id]
        }
      } else {
        // 选其它选项时，如“不清楚/不知道“选项已勾选，则取消勾选
        let unknownIndex = -1
        values.forEach((item, itemIndex) => {
          this.config[this.questionIndex].optionList.forEach(optionItem => {
            if (optionItem.type === 'unknown' && item === optionItem.id) {
              unknownIndex = itemIndex
            }
          })
        })
        if (unknownIndex > -1) {
          values.splice(unknownIndex, 1)
        }
      }

      this.$refs.formItem.validate()
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    },
    getSurveyInfoLang: function () {
      return this.surveyInfoLang
    },
    // 断点续答用于记录当前是否有选择的答案，用作valid
    collectSelIndexs() {
      this.$nextTick(() => {
        // 断点续答用于记录当前是否有选择的答案，用作valid
        if (this.config && this.config.length) {
          const arr = []
          this.config.forEach((item, index) => {
            const currItem = item.descList[item.descIndex]
            if ((item.elementType === 'RadioBoxGroup' && currItem.value) || (item.elementType === 'CheckBoxGroup' && currItem.value.length)) {
              arr.push(index)
            }
          })
          this.selIndexs = arr
        }
      })
    }
  },
  created () {},
  mounted () {
    this.collectSelIndexs()
  }
}
</script>
<style lang="scss" scoped>
.el-table {
  margin-bottom: 20px;
}

.title {
  .media-box {
    margin-top: 15px;
    display: flex;
    justify-content: center;
  }
}


.desc-list {
  .an-head {
    .title {
      .desc-style {
        flex-direction: column;
        .media-box {
          margin-top: 15px;
          display: flex;
          justify-content: center;
        }
        .title-box {
          padding-bottom: 40px;
          border-bottom: 1px solid #f1f1f1;
          .require {
            font-size: 36px;
            color: #FF645A;
          }
          .qu-num, .qu-title {
            font-size: 32px;
            font-weight: 500;
            color: #000;
            margin-right: 10px;
          }
        }
        .qu-type {
          color: #bbb;
        }
      }
    }
  }
}
.answer-pc {
  .desc-list {
    .an-head {
      .title {
        padding: 0 30px;
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;
        .require {
          font-size: 18px;
          color: #FF645A;
        }
        .qu-num, .qu-title {
          font-size: 18px;
          margin-right: 5px;
        }
      }
    }
    .an-body {
      padding: 30px 40px 0px 80px;
      >>> .el-table {
        .el-table__body {
          tr{
            td.el-table__cell {
              padding: 6px 0px;
              .el-radio, .el-checkbox {
                width: 32px !important;
                padding: 8px;
              }
            }
          }
          tr:hover {
            td.el-table__cell {
              background: none;
            }
            td.first-column {
              background: #fafafa;
            }
          }
        }
        .first-column {
          background: #fafafa;
          color: rgba(0, 0, 0, 0.85);
        }
        .el-table__header-wrapper {
          th {
            background: #fafafa;
            color: rgba(0, 0, 0, 0.85);
          }
          .first-column {
            background: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/answer/AnswerGroupTable.vue